import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import API from '../config';

const isValidKenyanPhone = (phone) => {
  const cleaned = phone.replace(/\s+/g, '');
  return /^(07|01)\d{8}$/.test(cleaned) || /^254(7|1)\d{8}$/.test(cleaned);
};

export default function AddPhoneModal({ onSuccess, onClose }) {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { token } = useAuth();
  const { T } = useTheme();

  const handleSubmit = async () => {
    if (!phone.trim()) return;

    if (!isValidKenyanPhone(phone)) {
      setError('Enter a valid Safaricom number e.g. 0712 345 678');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const res = await axios.patch(
        `${API}/api/users/phone`,
        { phone },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onSuccess(res.data.phone);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save number. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 999, padding: '0 16px',
    }}>
      <div style={{
        background: T.surface, border: `1px solid ${T.border}`,
        borderRadius: 16, padding: '32px 28px', maxWidth: 400, width: '100%',
        fontFamily: "'DM Sans', sans-serif",
      }}>
        <div style={{
          width: 56, height: 56, background: `${T.accent}18`,
          border: `1px solid ${T.accent}33`, borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 24, marginBottom: 20,
        }}>📱</div>

        <h3 style={{ fontSize: 20, fontWeight: 800, color: T.text, marginBottom: 8 }}>
          Add your M-Pesa number
        </h3>
        <p style={{ fontSize: 13, color: T.textMuted, marginBottom: 24, lineHeight: 1.5 }}>
          Add your M-Pesa number to deposit or withdraw via M-Pesa.
        </p>

        <label style={{ fontSize: 11, color: T.textDim, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 6 }}>
          M-Pesa Number
        </label>
        <input
          type="tel"
          value={phone}
          onChange={e => { setPhone(e.target.value); setError(''); }}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          placeholder="e.g. 0712 345 678"
          style={{
            width: '100%', background: T.surfaceHi,
            border: `1px solid ${error ? T.no : T.border}`,
            borderRadius: 8, padding: '13px 14px', color: T.text, fontSize: 14,
            outline: 'none', boxSizing: 'border-box', marginBottom: 8,
            fontFamily: "'DM Sans', sans-serif",
          }}
          autoFocus
        />

        {error && (
          <p style={{ fontSize: 13, color: T.no, marginBottom: 12 }}>⚠️ {error}</p>
        )}

        <button
          onClick={handleSubmit}
          disabled={loading || !phone.trim()}
          style={{
            width: '100%', background: loading || !phone.trim() ? T.surfaceHi : T.accent,
            color: loading || !phone.trim() ? T.textDim : '#fff',
            border: 'none', borderRadius: 8, padding: 14,
            fontSize: 14, fontWeight: 700, cursor: loading || !phone.trim() ? 'not-allowed' : 'pointer',
            marginBottom: 10, transition: 'all 0.2s',
          }}
        >
          {loading ? 'Saving...' : 'Save & Continue →'}
        </button>

        {onClose && (
          <button
            onClick={onClose}
            style={{
              width: '100%', background: 'transparent', color: T.textMuted,
              border: `1px solid ${T.border}`, borderRadius: 8, padding: 13,
              fontSize: 13, cursor: 'pointer',
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}